export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20fashion%20product%20flatlay%20with%20sneakers%20hoodies%20and%20caps%20on%20warm%20cream%20textured%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20left%2C%20editorial%20product%20photography%20with%20generous%20negative%20space%2C%20aesthetic%20lifestyle%20brand%20composition%2C%20warm%20neutral%20beige%20and%20sand%20tones&width=1800&height=1200&seq=usfans-hero-main-a1&orientation=landscape"
          alt="USFans Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-900/55 via-foreground-900/40 to-foreground-900/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5 flex flex-col items-start">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              USFans Spreadsheet<br />
              <span className="italic font-serif text-accent-300">Polska</span>
              <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-background-100/90">
                Największa baza arkuszy i rankingów 2026
              </span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-100/80 leading-relaxed max-w-lg">
              Odkryj najlepsze arkusze USFans, porównania twórców, rankingi i aktualne przewodniki. Wszystko, czego potrzebujesz, aby podjąć świadomą decyzję.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-6 py-3.5 text-sm font-semibold text-foreground-950 bg-accent-400 hover:bg-accent-300 rounded-full transition-all whitespace-nowrap"
              >
                Sprawdź najnowszy USFans Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-6 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/50 hover:bg-background-50/10 rounded-full transition-all whitespace-nowrap"
              >
                Porównaj arkusze
                <span className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-scales-line"></i>
                </span>
              </a>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-3">
              {[
                { text: 'Aktualizowane codziennie', icon: 'ri-refresh-line' },
                { text: 'Bezpieczne informacje', icon: 'ri-shield-check-line' },
                { text: 'Przewodniki ekspertów', icon: 'ri-award-line' },
                { text: 'Darmowe porównania', icon: 'ri-gift-line' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-sm text-background-100/80">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={item.icon}></i>
                  </span>
                  <span className="whitespace-nowrap">✓ {item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-3/5 w-full">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20sneaker%20and%20streetwear%20collection%20flatlay%20with%20multiple%20colorful%20shoes%20hoodies%20caps%20arranged%20artistically%20on%20warm%20cream%20backdrop%2C%20soft%20directional%20shadows%2C%20editorial%20catalog%20product%20photography%20with%20clean%20composition%2C%20warm%20natural%20studio%20lighting%2C%20minimalist%20brand%20aesthetic%20style&width=1200&height=800&seq=usfans-hero-product-b1&orientation=landscape"
                alt="USFans Spreadsheet kolekcja"
                className="w-full h-auto object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}